var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMliFeedBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2030_18582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7324 3.32715H5.73242C4.63242 3.32715 3.73242 4.22715 3.73242 5.32715V19.3271C3.73242 20.4271 4.63242 21.3271 5.73242 21.3271H19.7324C20.8324 21.3271 21.7324 20.4271 21.7324 19.3271V8.32715L16.7324 3.32715ZM19.7324 19.3271H5.73242V5.32715H15.7324V9.32715H19.7324V19.3271ZM7.73242 17.3271H17.7324V15.3271H7.73242V17.3271ZM12.7324 7.32715H7.73242V9.32715H12.7324V7.32715ZM7.73242 13.3271H17.7324V11.3271H7.73242V13.3271Z",
    fill: "#8B8C8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2030_18582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.732422 0.327148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMliFeedBlack);
export default __webpack_public_path__ + "static/media/mli-feed-black.3b27bfe77bbcef27fb49ce5611ea2a9b.svg";
export { ForwardRef as ReactComponent };